exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".trend-topic-list{\r\n    line-height: 30px;\r\n}\r\n.trend-topic-title{\r\n    font-size: 15px;\r\n    color: grey;\r\n}\r\n@media only screen and (max-width: 767px) {\r\n    .ulUs{\r\n        line-height:23px !important;\r\n    }\r\n    .trend-topic-listcategories{\r\n        letter-spacing:-1px !important;\r\n        line-height: 23px !important;\r\n     }\r\n    .trend-topic-list {\r\n        line-height: 23px !important;\r\n    }\r\n   \r\n    \r\n    \r\n    .bestPost{\r\n        margin: 0px -20px !important;\r\n        \r\n        }\r\n    .logo-footer-white {\r\n        float: unset;\r\n    }\r\n}\r\n.logo-footer-white {\r\n    float: right;\r\n}\r\n.trend-topic-list :hover{\r\n    color:#ee382c;\r\n\r\n}\r\n.tt :hover{\r\n    color:#ee382c;\r\n}\r\n.footer-links a:hover{\r\n    color:#ee382c;\r\n}\r\n.bestPost{\r\nmargin: 0px -33px;\r\n\r\n}\r\n.trend-topic-listcategories{\r\n   letter-spacing:-0.5px;\r\n   line-height: 30px;\r\n}\r\n.ulUs{\r\n    line-height:30px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/welcome-page/welcome-footer/welcome-footer.component.css
// module id = ../../../../../src/app/welcome-page/welcome-footer/welcome-footer.component.css
// module chunks = main